import axiosInstance from "../configs/axios";
import {route} from "ziggy-js";

const ERROR_FETCH_FAILED = 'Failed to fetch modal content';

/**
 * Fetches the modal content from the server based on the specified modal type and size.
 *
 * @param {string} modalType - The type of modal to be fetched (e.g., 'login', 'register').
 * @param {string} [size='modal-md'] - The size of the modal (e.g., 'modal-lg', 'modal-sm').
 * @param queryParams
 * @returns {Promise<string>} - A promise that resolves with the modal HTML content.
 * @throws {Error} - Throws an error if the API request fails or the response is not OK.
 */
export async function fetchModal(modalType, size = 'modal-md', queryParams = {}) {
    const urlParams = { type: modalType, size, ...queryParams };
    const url = route('jsapi.modal.get', urlParams);

    try {
        const response = await axiosInstance.get(url);

        if (response.status < 200 || response.status >= 300) {
            throw new Error(`${ERROR_FETCH_FAILED}: ${response.status} ${response.statusText}`);
        }

        return response.data;
    } catch (error) {
        throw new Error(`${ERROR_FETCH_FAILED}. ${error.message}`);
    }
}
